<template src="./riepilogoOre.html"></template>

<script>
import * as XLSX from 'xlsx';

import { get_utenti, get_clienti } from "@/api/api.calendar.js";

import TabellaRiepilogo from "./TabellaRiepilogo.vue";
import RiepilogoPreventivi from "./RiepilogoPreventivi.vue";
import FiltriRiepilogoOre from './FiltriRiepilogoOre.vue';
import DashboardOre from './DashboardOre.vue'; // NUOVO

import { get_oreClienti } from "@/api/api.clienti.js";
import mixinr from "./mixinRiepilogo.js";
import mixinRichieste from "./mixinRichieste.js";
import storage from "@/services/storage.js";

export default {

  components: {
    TabellaRiepilogo,
    FiltriRiepilogoOre,
    RiepilogoPreventivi,
    DashboardOre, // NUOVO
  },

  mixins: [mixinr, mixinRichieste],

  data: () => ({
    search: "",
    filtri: {},
    showFiltriMobile: false,

    calendarDataDa: false,
    calendarDataA: false,
    mcalendarDataDa: false,
    mcalendarDataA: false,

    elencoClienti: [],
    elencoOperatori: [],
    destinazioni: [],
    tipiOre: [],

    elencoDati: [],
    totaliPreventivi: [],
    totale: {},

    includiOreUfficio: false,
    raggruppaClienti: false,
    separaOperatori: false,
    soloDafatturare: true,

    // Dialog di dettaglio che si apre sul click di una riga ragguppata
    dettaglioDati: [],
    dialogInfo: false,
    dettaglioTotale: {},
    activeTab: 0,
  }),

  methods: {
    async caricaDati() {
      this.caricaOperatori();
      this.caricaClienti();
      this.caricaOreClienti();
    },

    async caricaOperatori() {
      let res = await get_utenti();
      this.elencoOperatori = res.data;
    },

    async caricaClienti() {
      let res = await get_clienti();
      this.elencoClienti = res.data;
    },

    async caricaOreClienti() {
      if (
        this.filtri.dataDa == null ||
        this.filtri.dataDa == "" ||
        this.filtri.dataA == null ||
        this.filtri.dataA == ""
      ) {
        return;
      }
      if (!this.intervalloValido) {
        this.$toast.alert("Data non valida: controlla data inizio e data fine");
        return;
      }
      if (!this.raggruppaClienti) this.separaOperatori = false;

      // Se i filtri cambiano più volte di seguito, la risposta di una richiesta vecchia non deve sostituire quella più recente
      const attuale = this.nuovaRichiesta('ore');
      try {
        let res = await get_oreClienti(
          "?raggruppa=" + (this.raggruppaClienti ? "1" : "0") +
          "&separaOp=" + (this.separaOperatori ? "1" : "0") +
          "&soloDafatturare=" + (this.soloDafatturare ? "1" : "0"),
          this.filtri
        );
        if (!attuale()) return;

        this.elencoDati = res.data.elenco;
        this.totale = res.data.totale;
        this.totaliPreventivi = res.data.totaliPreventivi;
      } catch (error) {
        if (!attuale()) return;

        // I dati a video non corrispondono più ai filtri scelti: li svuoto invece di lasciare quelli vecchi
        this.elencoDati = [];
        this.totale = {};
        this.totaliPreventivi = [];
      }
    },

    refresh() {
      this.caricaDati();
    },

    // Data nel formato aaaa-mm-gg secondo il fuso orario locale (toISOString userebbe l'UTC e di notte darebbe il giorno prima)
    formatData(date) {
      const mese = String(date.getMonth() + 1).padStart(2, "0");
      const giorno = String(date.getDate()).padStart(2, "0");
      return `${date.getFullYear()}-${mese}-${giorno}`;
    },

    // Dal primo giorno del mese a oggi
    dateDefault() {
      let date = new Date();
      this.filtri.dataA = this.formatData(date);
      this.filtri.dataDa = this.formatData(new Date(date.getFullYear(), date.getMonth(), 1));
    },

    async dettaglioCliente(item) {
      let filtriL = {};
      Object.assign(filtriL, this.filtri);

      // Le ore in ufficio senza cliente non hanno un dettaglio: non apro la finestra
      const nome = (item.cliente || "").trim();
      const cliente = nome ? this.elencoClienti.find((c) => (c.ragSoc || "").trim() == nome) : null;
      if (!cliente) return;

      filtriL.cliente = cliente.codAnagrafica;
      filtriL.destinazione = item.destinazione;
      if (this.separaOperatori) filtriL.operatore = [item.operatore];

      // Non mostro il dettaglio del cliente aperto in precedenza mentre arriva quello nuovo
      this.dettaglioDati = [];
      this.dettaglioTotale = {};
      this.dialogInfo = true;

      const attuale = this.nuovaRichiesta('dettaglio');
      let par = "?soloDafatturare=" + (this.soloDafatturare ? "1" : "0");
      try {
        let res = await get_oreClienti(par, filtriL);
        if (!attuale()) return;

        this.dettaglioDati = res.data.elenco;
        this.dettaglioTotale = res.data.totale;
      } catch (error) {
        if (attuale()) this.dialogInfo = false;
      }
    },

    getFullscreen() {
      return this.$functions.isMobile();
    },

    esportaExcel() {
      if (!this.elencoDati || this.elencoDati.length === 0) {
        this.$toast.alert("Nessun dato disponibile");
        return;
      }

      const wb = XLSX.utils.book_new();

      // ── FOGLIO 1: Riepilogo ore ──────────────────────────────────────────
      const headerFoglio1 = [
        ['Data', 'Operatore', 'Cliente', 'Ore', 'Destinazione', 'Totale Ore', 'Importo Totale', 'Da Fatturare']
      ];

      const wsFoglio1 = XLSX.utils.aoa_to_sheet(headerFoglio1);

      wsFoglio1['!cols'] = [
        { wch: 12 },  // Data
        { wch: 20 },  // Operatore
        { wch: 25 },  // Cliente
        { wch: 6 },  // Ore
        { wch: 14 },  // Destinazione
        { wch: 12 },  // Totale Ore
        { wch: 16 },  // Importo Totale
        { wch: 14 },  // Da Fatturare
      ];

      this.elencoDati.forEach((item, index) => {
        const row = [
          item.data,
          item.operatore,
          item.cliente,
          item.ore,
          item.destinazione,
          item.totaleOre,
          item.importoTotale,
          item.daFatturare ? 'Sì' : 'No',
        ];
        XLSX.utils.sheet_add_aoa(wsFoglio1, [row], { origin: index + 1 });
      });

      XLSX.utils.book_append_sheet(wb, wsFoglio1, 'Riepilogo ore');

      // ── FOGLIO 2: Prev e totali ──────────────────────────────────────────
      const headerFoglio2 = [
        ['Data', 'Operatore', 'Cliente', 'Descrizione', 'Tipo Importo', 'Totale Ore', 'Importo Totale', 'Da Fatturare']
      ];

      const wsFoglio2 = XLSX.utils.aoa_to_sheet(headerFoglio2);

      wsFoglio2['!cols'] = [
        { wch: 12 },  // Data
        { wch: 20 },  // Operatore
        { wch: 25 },  // Cliente
        { wch: 35 },  // Descrizione
        { wch: 14 },  // Tipo Importo
        { wch: 12 },  // Totale Ore
        { wch: 16 },  // Importo Totale
        { wch: 14 },  // Da Fatturare
      ];

      const datiPreventivi = Array.isArray(this.totaliPreventivi)
        ? this.totaliPreventivi
        : [this.totaliPreventivi];

      datiPreventivi.forEach((item, index) => {
        const row = [
          item.data,
          item.operatore,
          item.cliente,
          item.descrizione,
          item.tipoImporto,
          item.totaleOre,
          item.importoTotale,
          item.daFatturare ? 'Sì' : 'No',
        ];
        XLSX.utils.sheet_add_aoa(wsFoglio2, [row], { origin: index + 1 });
      });

      XLSX.utils.book_append_sheet(wb, wsFoglio2, 'Prev e totali');

      // ── Export ───────────────────────────────────────────────────────────
      XLSX.writeFile(wb, 'riepilogo_ore.xlsx');
    },
  },

  mounted() {
    this.filtri = this.getFiltri();
    this.destinazioni = this.getDestinazioni();
    this.tipiOre = this.getTipiOre();

    this.dateDefault();
    this.caricaDati();
  },

  created() {
    if (this.role != "admin") this.$router.push({ path: "/" });
  },

  computed: {
    role() {
      return storage.getRole();
    },

    // Data inizio non successiva a data fine, e anni plausibili (mentre si digita l'anno compaiono date come 0002-10-01)
    intervalloValido() {
      const { dataDa, dataA } = this.filtri;
      const annoValido = (d) => !d || parseInt(String(d).substring(0, 4), 10) >= 1900;
      if (!annoValido(dataDa) || !annoValido(dataA)) return false;
      return !(dataDa && dataA && dataDa > dataA);
    },
  },

  watch: {
    // Le date non vengono più riportate al valore precedente quando non sono coerenti: digitando l'anno di una data si
    // passa per valori intermedi (es. 0002-10-23) che farebbero tornare indietro il campo a ogni cifra.
    // Il controllo avviene al caricamento dei dati e i campi con date non valide diventano rossi.
    "filtri.dataDa": function () {
      this.filtri.dataDaIT = this.$i2kFunctions.formatISODate(
        this.filtri.dataDa
      );
    },

    "filtri.dataA": function () {
      this.filtri.dataAIT = this.$i2kFunctions.formatISODate(this.filtri.dataA);
    },
  },
};
</script>

<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}

.totale {
  font-weight: bold;
  font-size: 1.1em;
  padding: 0;
  vertical-align: middle;
  display: flex;
  align-items: center;
}

.desktop-filters {
  border-radius: 5px;
  padding: 0.5rem;
}

.mobile-filters-toggle {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  background: var(--v-primary-base);
  color: white;
  border-radius: 50%;
}

.conteggio-prev {
  font-weight: bold;
  font-size: 1.2em;
}
</style>